import { motion as m } from "framer-motion";
const WidgetCard = ({ name, data, content }) => {
  return (
    <m.div
      className="flex flex-col border border-[#EFF0F2] w-full h-fit p-[24px] gap-[12px] bg-white rounded-xl"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h2 className="text-[14px] truncate">{name}</h2>
      <h1 className="text-[29px]">{data}</h1>
      <div>{content}</div>
    </m.div>
  );
};

export default WidgetCard;
